import Api from 'libs/api';

import AuthService from 'services/Auth';

class SpecialMenuApi extends Api {
  constructor(restaurantID) {
    const resId = restaurantID || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/special_menus`);
  }
}

export default SpecialMenuApi;
